var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('div',{staticClass:"mt-5 pt-5"},[_c('router-view'),_c('fab',{attrs:{"draggable":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }